import React, { useRef } from "react";
import styles from "./index.module.css";
import { useState } from "react";
import { toast } from "react-toastify";
import { sendOTP, verifyOTP } from "../../../api/auth";

const ConfirmOTP = (props) => {
  const [otp, setOtp] = useState(Array(6).fill(""));
  const [loader, setLoader] = useState(false);
  const inputs = useRef([]);

  const handleChange = (e, index) => {
    const { value } = e.target;

    if (value.match(/^\d$/)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      if (index < 5) {
        inputs.current[index + 1].focus();
      }
    }

    if (value === "" && index > 0) {
      inputs.current[index - 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && otp[index] === "") {
      if (index > 0) {
        inputs.current[index - 1].focus();
      }
    }
  };

  const debounce = (func) => {
    let timer;
    return () => {
      clearTimeout(timer);
      timer = setTimeout(func, 300);
    };
  };

  const handleVerify = () => {
    if (!loader) {
      const code = otp.join("");

      if (code.length < 6) {
        toast.error("6 digit OTP required!");
      } else {
        setLoader(true);
        verifyOTP(code, props.username).then((res) => {
          setLoader(false);
          if (res.status == "success") {
            toast.success("OTP verified!");
            sessionStorage.setItem("secret", res.data.secret);
            props.setVisibility({
              forgotYourPassword: false,
              confirmOTP: false,
              enterNewPassword: true,
            });
          } else {
            toast.error(res.message);
          }
        });
      }
    }
  };

  const resendOTP = () => {
    if (!loader) {
      const username = sessionStorage.getItem("username");
      if (username) {
        setLoader(true);
        sendOTP(username).then((res) => {
          setLoader(false);
          if (res.status === "success") {
            toast.success(res.message);
          } else {
            toast.error(res.message);
          }
        });
      }
    }
  };

  return (
    <div className={styles["container"]}>
      {" "}
      <div className={styles["form"]}>
        <div className={styles["text"]}>
          <div className={styles["main"]}>Confirm OTP</div>
          <div className={styles["sub"]}>
            We have sent you an OTP to your associated email address
          </div>
        </div>
        <div className={styles["inputs"]}>
          <div className={styles["input_box"]}>
            <div className={styles["label"]}>OTP</div>
            <div className={styles["input"]}>
              {otp.map((_, index) => (
                <input
                  key={index}
                  type="text"
                  placeholder="-"
                  maxLength={"1"}
                  onChange={(e) => handleChange(e, index)}
                  onKeyDown={(e) => handleKeyDown(e, index)}
                  ref={(el) => (inputs.current[index] = el)}
                />
              ))}
            </div>
          </div>
        </div>
        <div className={styles["submission"]}>
          <div className={styles["main_cta"]}>
            <div className={styles["button"]} onClick={debounce(handleVerify)}>
              Confirm OTP
            </div>
            <div
              className={styles["button"] + " " + styles["resend"]}
              onClick={debounce(resendOTP)}
            >
              Resend
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmOTP;
